/**
 * login
 */

export default [{
  name: 'login',
  path: '/login',
  meta: {
    title: '',
    href: '/login',
    redirect: 'noredirect'
  },
  component: () => import( /* webpackChunkName: 'login' */ '@/layouts/login'),
},
{
  name: 'lock',
  path: '/lock',
  meta: {
    title: '锁屏',
    href: '/lock',
    redirect: 'noredirect'
  },
  component: () => import( /* webpackChunkName: 'lock' */ '@/layouts/lock'),
},
{
  name: 'restPasswork',
  path: '/restPasswork',
  meta: {
    title: '重置密码',
    href: '/restPasswork',
    redirect: 'noredirect'
  },
  component: () => import( /* webpackChunkName: 'restPasswork' */ '@/layouts/restPasswork'),
}
];
